import { render, staticRenderFns } from "./DepartmentAccountList.vue?vue&type=template&id=5cb6eb96&"
import script from "./DepartmentAccountList.vue?vue&type=script&lang=js&"
export * from "./DepartmentAccountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports